import { useDasBalanceContext } from '@did/das-app-context'
import { useEffect, useState } from 'react'
import { IDidPointConfigInfoRes } from '@did/types'
export const useConfig = () => {
  const { services } = useDasBalanceContext()
  const [config, setConfig] = useState<IDidPointConfigInfoRes>()

  useEffect(() => {
    const getConfig = async () => {
      const res = await services.didPoint.didPointConfigInfo()
      setConfig(res)
    }
    getConfig()
  }, [])

  return {
    config
  }
}
